import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { deleteTeamAction } from 'src/redux/actions/ambassadorActions';

const DeleteAmbassadorDialog = () => {
  const dispatch = useAppDispatch();
  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteAmbassador]) {
        return state.dialog[DIALOGS.deleteAmbassador];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteAmbassador }));
  };

  const handleOk = () => {
    if (payload) {
      dispatch(deleteTeamAction(payload));
    }
    dispatch(closeDialog({ dialog: DIALOGS.deleteAmbassador }));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-contact"
      open={opened}>
      <DialogTitle id="deleting-contact">Deleting ambassador</DialogTitle>
      <DialogContent dividers>
        Are you sure you want to delete that ambassador?
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAmbassadorDialog;
